const firebaseConfig = {
  apiKey: "AIzaSyADIC4JfKjoh7Tfjsii99p0PnkPFH2Nwhg",

  authDomain: "where-s-wally-f5181.firebaseapp.com",

  projectId: "where-s-wally-f5181",

  storageBucket: "where-s-wally-f5181.appspot.com",

  messagingSenderId: "432283973613",

  appId: "1:432283973613:web:b74462499c1b02952019e4",

  measurementId: "G-DQD7GE5LP7",
};

const getFirebaseConfig = () => {
  return firebaseConfig;
};

export default getFirebaseConfig;
